import { http, HttpResponse } from 'msw'
import { UnsecuredJWT } from 'jose'
import { StatusCodes } from 'http-status-codes'

import { api } from '@/utils/constants'

import { AuthTokens } from '@/types/auth/tokens'
import { AccountActivationPayload } from '@/types/user/account'

export const activateAccount = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.ACTIVATION}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = AccountActivationPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const jwtBody = {
            zer: 'aze',
        }

        const accessToken = new UnsecuredJWT(jwtBody)
            .setIssuedAt()
            .setExpirationTime('1d')
            .encode()

        const refreshToken = new UnsecuredJWT(jwtBody)
            .setIssuedAt()
            .setExpirationTime('15d')
            .encode()

        return HttpResponse.json<AuthTokens>({
            access_token: accessToken,
            refresh_token: refreshToken,
        })
    },
)
